import React from 'react'
import { useLocation } from 'react-router-dom'
import PageSeo from './PageSeo'
import { resolvePageSeoForPath } from '../../constants/pageSeoRegistry'

/** 라우트 경로별 정적 SEO — 동적 상세 페이지는 각 뷰의 PageSeo가 담당 */
const RouteSeoManager = () => {
    const { pathname } = useLocation()
    const seo = resolvePageSeoForPath(pathname)

    if (!seo) {
        return null
    }

    return <PageSeo seo={seo} />
}

export default RouteSeoManager
